import { LoadingStatusType } from "@/enums/enums";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import API from "@/service/index";
import { ClassificationItemListModel, ClassificationItemModel, ClassificationListModel } from "@/model/classification";
import {
  ConvertToClassificationItemList,
  ConvertToClassificationList,
} from "@/service/classification/classificationFacade";

@Module({ namespaced: true })
export default class Classification extends VuexModule {
  public classificationList: Array<ClassificationListModel> = new Array<ClassificationListModel>();
  public classificationListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public classificationItemList: Array<ClassificationItemModel> = new Array<ClassificationItemModel>();
  public classificationItemLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getClassificationListLoadingStatus(): LoadingStatusType {
    return this.classificationListLoadingStatus;
  }
  get getClassificationList(): Array<ClassificationListModel> {
    let classificationList = new Array<ClassificationListModel>();
    classificationList = this.classificationList.filter((x: ClassificationListModel) => !x.isDeleted);
    return classificationList;
  }
  get getClassificationItemLoadingStatus(): LoadingStatusType {
    return this.classificationItemLoadingStatus;
  }
  get getClassificationItemList(): Array<ClassificationItemModel> {
    const classificationItemList = new Array<ClassificationItemModel>();
    this.classificationItemList.forEach((element: ClassificationItemModel) => {
      classificationItemList.push({
        classificationId: element.classificationId,
        classificationItemList: element.classificationItemList.filter((x: ClassificationItemListModel) => !x.isDeleted),
      });
    });
    return classificationItemList;
  }

  @Mutation
  public MutationClassificationListLoadingStatus(status: LoadingStatusType) {
    this.classificationListLoadingStatus = status;
  }
  @Mutation
  public MutationClassificationList(classificationList: Array<ClassificationListModel>) {
    this.classificationList = classificationList;
  }
  @Mutation
  public MutationClassificationItemLoadingStatus(status: LoadingStatusType) {
    this.classificationItemLoadingStatus = status;
  }
  @Mutation
  public MutationClassificationItemList(classificationItem: ClassificationItemModel) {
    if (this.classificationItemList.length > 0) {
      const index = this.classificationItemList.findIndex(
        (x) => x.classificationId === classificationItem.classificationId
      );
      if (index > -1) {
        this.classificationItemList[index].classificationItemList = classificationItem.classificationItemList;
      } else {
        this.classificationItemList.push({
          classificationId: classificationItem.classificationId,
          classificationItemList: classificationItem.classificationItemList,
        });
      }
    } else {
      this.classificationItemList.push({
        classificationId: classificationItem.classificationId,
        classificationItemList: classificationItem.classificationItemList,
      });
    }
  }

  @Action
  DoGetClassificationList() {
    if (this.classificationListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationClassificationListLoadingStatus", LoadingStatusType.Loading);
      API.ClassificationService.DoGetClassificationList().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const classificationList = ConvertToClassificationList(res.data.allocationList);
          this.context.commit("MutationClassificationList", classificationList);
        }
        this.context.commit("MutationClassificationListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  DoGetClassificationItemList(classificationId: number) {
    if (this.classificationItemLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationClassificationItemLoadingStatus", LoadingStatusType.Loading);
      API.ClassificationService.DoGetClassificationItemList(classificationId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const classificationItemList = ConvertToClassificationItemList(res.data.allocationItemList);
          this.context.commit("MutationClassificationItemList", {
            classificationItemList: classificationItemList,
            classificationId: classificationId,
          });
        }
        this.context.commit("MutationClassificationItemLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
}
